import { createAsyncThunk } from '@reduxjs/toolkit'
import CoherentScreenMediaReference from './coherent-screen-media-reference-model'
import {
  delete_coherentScreenMediaReference,
  load_coherentScreenMediaReferences,
  store_coherentScreenMediaReference,
} from './coherentScreenMediaReference-service'

export const LoadCoherentScreenMediaReferencesAsync = createAsyncThunk<
  any,
  any
>(
  'composer/load/coherentScreenMediaReference',
  async (params: { uid: string }) => {
    return await load_coherentScreenMediaReferences(params)
  },
)

export const CreateCoherentScreenMediaReferenceAsync = createAsyncThunk<
  any,
  any
>(
  'composer/create/coherentScreenMediaReference',
  async (params: CoherentScreenMediaReference) => {
    return await store_coherentScreenMediaReference(params)
  },
)

export const DeleteCoherentScreenMediaReferenceAsync = createAsyncThunk<
  any,
  any
>('composer/delete/coherentScreenMediaReference', async (params) => {
  return await delete_coherentScreenMediaReference(params)
})
